module.exports = __webpack_public_path__ + "img/zy-logo.71705a21.png";